import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl, logError } from 'src/utils/ApiHelper';
import {
  ASSIGNED_SUPPORT_REQUESTS,
  CSA,
  REQUESTED_SUPPORT_REQUESTS,
  SUCCESS_MESSAGES
} from '../contants';
import {
  setFieldSupportFilterSchema,
  setLoading,
  setRequestedFieldSupport,
  setTasksForMe,
  setTasksForMeFilterSchema
} from '../reducers/CsaCoordinationSlice';
import { IUpdateTicketStatus } from '../types';
import { getFilterSchema, getPayloadForFetchTickets } from '../utils';
import { API_STATUS_CODE } from '@cp/src/utils/ApiHelperUtils';

export const fetchTicketsForTable =
  (userId?: string, isFieldSupport = false) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_CSA_TICKETS);
    dispatch(setLoading(true));
    const payload = getPayloadForFetchTickets(isFieldSupport, userId);
    axiosInstance
      .post(url, payload)
      .then(response => {
        if (response.status === API_STATUS_CODE.OK) {
          if (isFieldSupport) dispatch(setRequestedFieldSupport(response?.data));
          else dispatch(setTasksForMe(response?.data));
        }
      })
      .catch(err => {
        logError(err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

export const fetchDynamicFilters =
  (isFieldSupport = false) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_CSA_FILTERS);
    axiosInstance
      .get(url, {
        params: {
          tabType: isFieldSupport ? REQUESTED_SUPPORT_REQUESTS : ASSIGNED_SUPPORT_REQUESTS
        }
      })
      .then(response => {
        if (response.status === API_STATUS_CODE.OK) {
          const transformedObject = getFilterSchema(response?.data);
          if (isFieldSupport) dispatch(setFieldSupportFilterSchema(transformedObject));
          else dispatch(setTasksForMeFilterSchema(transformedObject));
        }
      })
      .catch(err => {
        logError(err);
      })
      .finally(() => {});
  };

export const updateTicketStatus = ({
  payload,
  successCallbackFn,
  finallyCallBackFn,
  errorCallbackFn
}: IUpdateTicketStatus) => {
  const { ticketReferenceId, status, comment, address } = payload || {};
  const url = getApiUrl(ApiKeys.UPDATE_TICKET_STATUS, {
    ticketReferenceId
  });
  axiosInstance
    .put(url, { status, comment, address, supportRequestUserType: CSA })
    .then(response => {
      if (response.status === API_STATUS_CODE.OK) {
        toast(SUCCESS_MESSAGES.STATUS_UPDATED, { type: 'success' });
        addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_TASK_STATUS_UPDATED_SUCCESSFUL, {
          ticketId: ticketReferenceId
        });
        successCallbackFn?.();
      }
    })
    .catch(err => {
      errorCallbackFn?.();
      logError(err);
    })
    .finally(() => {
      finallyCallBackFn?.();
    });
};
